import Component from "./trainings.component";
import { Config } from "./trainings.config";
import { watchTrainings as saga } from "./redux/trainings.sagas";
import { reducer } from "./redux/trainings.reducer";

export default { Component, saga, reducer, config: Config };
